import { useConnection } from "@solana/wallet-adapter-react";
import type { FarmInfoDataMap, RaydiumFarmPosition } from "@stepfinance/farms";
import { loadRaydiumFarmPositions } from "@stepfinance/farms";
import { useEffect, useState } from "react";

import { useEnrichedWallet } from "../../contexts/enrichedWallet";
import { useLiquidity } from "../../contexts/liquidity";
import { useMarkets } from "../../contexts/market";
import { getTokenMap } from "../../utils/tokenInfo";

export function useRaydiumFarms(raydiumFarmInfoMap: FarmInfoDataMap<"Raydium">) {
  const { connection } = useConnection();
  const { connected, publicKey } = useEnrichedWallet();
  const { marketsInitialised, priceInUSD, refreshing: marketsRefreshing } = useMarkets();
  const { raydiumPools } = useLiquidity();
  const [farms, setFarms] = useState<RaydiumFarmPosition[]>([]);

  useEffect(() => setFarms([]), [connected]);

  useEffect(() => {
    const marketsRefreshFinished = !marketsRefreshing;
    if (
      publicKey &&
      marketsInitialised &&
      marketsRefreshFinished &&
      Object.values(raydiumPools).length > 0 &&
      Object.values(raydiumFarmInfoMap).length > 0
    ) {
      void loadRaydiumFarmPositions(
        publicKey,
        connection,
        getTokenMap(),
        priceInUSD,
        raydiumPools,
        raydiumFarmInfoMap,
      ).then(setFarms);
    }
  }, [
    raydiumPools,
    connection,
    connected,
    marketsInitialised,
    marketsRefreshing,
    priceInUSD,
    publicKey,
    raydiumFarmInfoMap,
  ]);

  return farms;
}
